export const saveGuestInfo = (guestInfo) => {
  return {
    type : 'GUEST_INFO_SAVE',
    guestInfo
  }
};